import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointsMadeFuel = {
  CREATE: '/v1/purchases/made',
  LOAD: ({ filter, sort, limit, skip, dateFrom, dateTo }) =>
    `/v1/purchases/made${haveFilterQuery(filter)}${
      dateFrom ? `&dateFrom=${dateFrom}` : ''
    }${dateTo ? `&dateTo=${dateTo}` : ''}${paginator(limit, skip)}${haveSort(sort)}`,
  LOAD_LAST: ({ filter, sort, limit, skip }) =>
    `/v1/purchases/made/last${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  LOAD_BY_OWN_STATION: ({ id, filter, sort, limit, skip }) =>
    `/v1/purchases/made/ownStation/${id}${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/purchases/made/${id}`,
}

export default endpointsMadeFuel
